export default __webpack_public_path__ + "static/media/register1.e81526c5.jpg";